import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  overflow: auto;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 50px 40px;\n\n  @media screen and (max-height: 500px) and (orientation: landscape) {\n    padding: 20px;\n\n    img {\n      width: 48px;\n      margin-bottom: 15px;\n    }\n  }\n\n  @media screen and (max-height: 400px) and (orientation: landscape) {\n    img {\n      display: none;\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 auto 24px;\n  max-width: 104px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 auto 24px;\n  max-width: 104px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from '../utils/styling/styled-components';
import { CONFIRMATION_MODAL_SIMPLE_IMAGE, CONFIRMATION_MODAL_CUSTOM_IMAGE } from '../utils/testing/TestIDs';
import { ButtonStyle } from './types';
import { ModalBody as Body, ModalTitle as Title } from './typography';
import { ConfirmationModalBase } from './ConfirmationModalBase';
var MODAL_LABEL = 'modal_label';
var MODAL_DESCRIPTION = 'modal_description';
var ModalImage = styled.img(_templateObject());
var IconContainer = styled.div(_templateObject2());
var ModalMessage = styled.div(_templateObject3());

var renderImage = function renderImage(image) {
  if (typeof image === 'string') {
    return /*#__PURE__*/React.createElement(ModalImage, {
      alt: '',
      src: image,
      "data-testid": CONFIRMATION_MODAL_SIMPLE_IMAGE
    });
  }

  if (image && 'src' in image) {
    return /*#__PURE__*/React.createElement(ModalImage, {
      alt: image.alt,
      src: image.src,
      "data-testid": CONFIRMATION_MODAL_CUSTOM_IMAGE
    });
  }

  return /*#__PURE__*/React.createElement(IconContainer, null, image);
};

var renderContent = function renderContent(prop) {
  return typeof prop === 'function' ? prop() : prop;
};

var ConfirmationModal = function ConfirmationModal(_ref) {
  var _ref$buttonStyle = _ref.buttonStyle,
      buttonStyle = _ref$buttonStyle === void 0 ? ButtonStyle.row : _ref$buttonStyle,
      image = _ref.image,
      message = _ref.message,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["buttonStyle", "image", "message", "title"]);

  return /*#__PURE__*/React.createElement(ConfirmationModalBase, _extends({
    accessibilityProperties: {
      labelledBy: title && MODAL_LABEL,
      describedBy: MODAL_DESCRIPTION
    },
    buttonStyle: buttonStyle
  }, rest), /*#__PURE__*/React.createElement(ModalMessage, null, image && renderImage(image), title && /*#__PURE__*/React.createElement(Title, {
    id: MODAL_LABEL
  }, renderContent(title)), /*#__PURE__*/React.createElement(Body, {
    id: MODAL_DESCRIPTION
  }, renderContent(message))));
};

export { ConfirmationModal, ModalImage, ModalMessage };